export default __webpack_public_path__ + "static/media/ChaletComprime-HongKongSixty.810b3157.woff";